var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("bootstrap-slider", {
        staticClass: "slider-question",
        attrs: {
          value: _vm.value,
          options: {
            range: true,
            min: _vm.min,
            max: _vm.max,
            ticks: [_vm.min, _vm.max],
            ticks_positions: [0, 100],
            ticks_labels: [_vm.min, _vm.max],
            enabled: _vm.canEdit
          }
        },
        on: {
          "change-value": function($event) {
            _vm.value = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.isFreeInput
        ? _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.valueMin,
                  expression: "valueMin",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control free-input free-input-min",
              attrs: {
                type: "number",
                min: _vm.min,
                max: _vm.valueMax,
                disabled: !_vm.canEdit
              },
              domProps: { value: _vm.valueMin },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.valueMin = _vm._n($event.target.value)
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.valueMax,
                  expression: "valueMax",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control free-input free-input-max",
              attrs: {
                type: "number",
                min: _vm.valueMin,
                max: _vm.max,
                disabled: !_vm.canEdit
              },
              domProps: { value: _vm.valueMax },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.valueMax = _vm._n($event.target.value)
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }